import MachineManageContainer from 'components/feature/machine/MachineManageContainer';
import React from 'react';

const MachineManagePage = () => {
  return <MachineManageContainer />;
};

export default MachineManagePage;
